import { c as _c } from "react/compiler-runtime";
import { Card, CardContent } from '@achra/ui/card';
import { cn } from '@achra/ui/lib/utils';
interface ActionCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  bgImage: React.ReactNode;
}
function ActionCard(t0) {
  const $ = _c(12);
  const {
    icon,
    title,
    description,
    bgImage
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex flex-col items-center gap-2 px-0");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <span className="text-foreground text-sm/5.5 font-semibold">{title}</span>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== icon || $[4] !== t2) {
    t3 = <div className="flex w-fit items-center gap-2">{icon}{t2}</div>;
    $[3] = icon;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== description) {
    t4 = <span className="text-foreground/50 w-full text-center text-xs/4.5 font-medium">{description}</span>;
    $[6] = description;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== bgImage || $[9] !== t3 || $[10] !== t4) {
    t5 = <Card className="hover:bg-accent bg-background border-border relative min-h-23 w-full rounded-lg p-3 shadow-none"><CardContent className={t1}>{t3}{t4}{bgImage}</CardContent></Card>;
    $[8] = bgImage;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export { ActionCard };